import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import Link from 'react-router/lib/Link';
import { t } from '../../../../../modules/infra/i18n';
import Checkbox from '../../../../common/Checkbox';
import Pagination from '../../../../common/Pagination';


const UsersList = ({ adminUsers, pagination, page, onPageChange }) => (
  <div>
    <ReactTable
      className="c-table-new c-no-hover c-table-paginated"
      data={adminUsers}
      minRows={0}
      defaultPageSize={10000}
      showPagination={false}
      resizable={false}
      columns={[
        {
          Header: t('admin:users.list.username_header'),
          accessor: 'username',
          id: 'username',
          className: 'u-text-center',
        },
        {
          Header: t('admin:users.list.permissions_header'),
          accessor: user => (user.permissions || []).map(({ operation }) => operation).join(', '),
          id: 'permissions',
          className: 'u-text-center',
        },
        {
          Header: t('admin:users.list.active_header'),
          accessor: 'enabled',
          id: 'enabled',
          className: 'u-text-center',
          Cell: row => (
            <Checkbox checked={row.value} readOnly />
          ),
        },
        {
          Header: t('admin:users.list.actions_header'),
          accessor: 'id',
          className: 'u-text-center',
          sortable: false,
          width: 100,
          Cell: row => (
            <Link className="u-co-primary u-type--bold" to={`/admin/users/${row.value}`}>{t('admin:users.list.edit_action')}</Link>
          ),
        },
      ]}
    />
    <Pagination
      display-if={adminUsers.length}
      onPageChange={onPageChange}
      pageCount={pagination.totalPages}
      currentPage={page}
    />
  </div>
);

UsersList.propTypes = {
  adminUsers: PropTypes.array,
  page: PropTypes.number.isRequired,
  pagination: PropTypes.shape({
    count: PropTypes.number,
    totalPages: PropTypes.number,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
};

UsersList.defaultProps = {
  adminUsers: [],
};

export default UsersList;
